import Tooltip from '@r1-frontend/ui-react/components/tooltip';
import PropTypes from 'prop-types';
import React from 'react';

import * as ST from './styled';

export const Tariff = ({ item, btnClick, isAuth }) => {
    const { id, name, cost, about, count, ncount, contain, devices } = item;

    return (
        <ST.Tariff>
            <ST.TariffHead>
                <ST.Row>
                    <ST.TariffTitle>{name}</ST.TariffTitle>
                    <ST.TariffCost>{cost}</ST.TariffCost>
                    <ST.Measure>руб.<br/>в мес.</ST.Measure>
                </ST.Row>
                <ST.TariffAbout>{about}</ST.TariffAbout>
            </ST.TariffHead>

            <ST.TariffDescription>

                <ST.TariffCount dangerouslySetInnerHTML={{ __html: count }} count={ncount}/>

                {contain.map(item => {
                    const { id, icon, isActive, name, desc } = item;
                    return (
                        <ST.TariffContain key={id}>
                            <ST.TariffIcon src={icon} isActive={isActive}/>
                            <ST.TextWrap>
                                <ST.TariffText >{name}</ST.TariffText>
                                <ST.ActiveText isActive={isActive}>{isActive ? 'входит в тариф' : 'не входит в тариф'}</ST.ActiveText>
                            </ST.TextWrap>
                            <Tooltip stateful={true} parent={<ST.Question/>} position='top' arrow='center'>
                                <ST.TooltipText>{desc}</ST.TooltipText>
                            </Tooltip>
                        </ST.TariffContain>
                    );
                })}

                <ST.DivicesWrap>
                    <ST.DivicesLabel>Дополнительные устройства для просмотра ТВ-каналов:</ST.DivicesLabel>
                    <ST.DivicesList>
                        {devices.map((item, index) => {
                            const { name, desc, isActive } = item;
                            return (
                                <ST.DivicesItem key={index}>
                                    <ST.Check isActive={isActive}/>
                                    <Tooltip stateful={true} parent={<ST.DivicesText isActive={isActive}>{name}</ST.DivicesText>} position='top' arrow='center'>
                                        <ST.TooltipText dangerouslySetInnerHTML={{ __html: desc }}/>
                                    </Tooltip>
                                </ST.DivicesItem>
                            );
                        })}
                    </ST.DivicesList>
                </ST.DivicesWrap>

                {
                    !isAuth &&
                    <ST.Button
                        data-test={`btnPopup-${id}`}
                        type='primary'
                        href={isAuth ? 'https://lk.dom.ru/domrutv/watch-everywhere' : ''}
                        onClick={() => !isAuth && btnClick(id)}
                    >
                        Подключить
                    </ST.Button>
                }

            </ST.TariffDescription>
        </ST.Tariff>
    );
};

Tariff.defaultProps = {
    btnClick: ()=>{},
};

Tariff.propTypes = {
    item: PropTypes.object.isRequired,
    btnClick: PropTypes.func,
    isAuth: PropTypes.bool.isRequired,
};
